import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { ArrowRight, Clock } from 'lucide-react';
import { posts } from '../../content/blog';

const BlogIndex = () => (
    <main className="bg-white">
        <Helmet>
            <title>Blog: guías de bicicletas | PROOMTB & ROAD</title>
        </Helmet>
        <header className="bg-zinc-950 text-white">
            <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-24">
                <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
                    <span className="inline-block py-1 px-3 border border-white/30 text-xs font-bold uppercase tracking-[0.2em] mb-6">Blog</span>
                    <h1 className="text-5xl md:text-7xl font-black uppercase italic tracking-tight leading-none mb-6">Guías para<br /><span className="gradient-text">rodar mejor</span></h1>
                    <p className="text-lg text-zinc-400 max-w-2xl">Tallas, bicicletas eléctricas, mantenimiento y comparativas, explicado por el equipo de PROOMTB & ROAD en Santo Domingo.</p>
                </motion.div>
            </div>
        </header>
        <section className="max-w-[1400px] mx-auto px-6 md:px-12 py-20">
            <motion.div initial="hidden" animate="show" transition={{ staggerChildren: 0.08 }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {posts.map((post) => (
                    <motion.div key={post.slug} variants={{ hidden: { opacity: 0, y: 30 }, show: { opacity: 1, y: 0 } }}>
                        <Link to={`/blog/${post.slug}`} className="group flex flex-col h-full rounded-3xl border border-zinc-200 hover:border-black overflow-hidden transition-colors">
                            <div className="aspect-[16/10] bg-gradient-to-b from-white to-zinc-100 flex items-center justify-center p-8">
                                {post.cover?.src && <img loading="lazy" decoding="async" src={post.cover.src} alt={post.cover.alt} className="max-h-full max-w-full object-contain mix-blend-multiply group-hover:scale-105 transition-transform duration-500" />}
                            </div>
                            <div className="p-6 flex flex-col flex-1">
                                <div className="flex items-center justify-between text-xs font-bold uppercase tracking-[0.2em] text-gray-400 mb-3">
                                    <span>{post.category}</span>
                                    <span className="flex items-center gap-1 normal-case tracking-normal font-medium"><Clock className="w-3 h-3" />{post.readingMinutes} min</span>
                                </div>
                                <h2 className="text-xl font-black italic leading-snug mb-3">{post.title}</h2>
                                <p className="text-gray-600 text-sm leading-relaxed flex-1">{post.description}</p>
                                <span className="inline-flex items-center gap-2 mt-5 text-xs font-bold uppercase tracking-widest">Leer <ArrowRight className="w-4 h-4 group-hover:translate-x-2 transition-transform" /></span>
                            </div>
                        </Link>
                    </motion.div>
                ))}
            </motion.div>
        </section>
    </main>
);

export default BlogIndex;
